/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cool_Warm_Cod_ScanInputs */

const en_cool_warm_cod_scan = /** @type {(inputs: Cool_Warm_Cod_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage access to user's peer feedback`)
};

const de_cool_warm_cod_scan = /** @type {(inputs: Cool_Warm_Cod_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriff auf peer feedback des Benutzers verwalten`)
};

/**
* | output |
* | --- |
* | "Manage access to user's peer feedback" |
*
* @param {Cool_Warm_Cod_ScanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_warm_cod_scan = /** @type {((inputs?: Cool_Warm_Cod_ScanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Warm_Cod_ScanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_warm_cod_scan(inputs)
	return de_cool_warm_cod_scan(inputs)
});